import { EntityKind } from '../entity/entity-kind.js';
import { createPermission, PermissionRead, PermissionWrite } from '../permission/permissions.js';

export const PermissionTrackerRead = createPermission(EntityKind.Tracker, PermissionRead);
export const PermissionTrackerWrite = createPermission(EntityKind.Tracker, PermissionWrite);